export const knowledgeTestV1AnswerScore = {
  KNOWLEDGE_TEST: {
    CRYPTOCURRENCY: {
      Q_1: {
        A_1: 1,
        A_2: 0,
        A_3: 0
      },
      Q_2: {
        A_1: 1,
        A_2: 0,
        A_3: 0
      },
      Q_3: {
        A_1: 0,
        A_2: 1,
        A_3: 0,
        A_4: 0
      },
      Q_4: {
        A_1: 1,
        A_2: 0,
        A_3: 0,
        A_4: 0
      },
      Q_5: {
        A_1: 0,
        A_2: 1,
        A_3: 0,
        A_4: 0
      },
      Q_6: {
        A_1: 1,
        A_2: 0,
        A_3: 0,
        A_4: 0
      },
      Q_7: {
        A_1: 0,
        A_2: 1,
        A_3: 0,
        A_4: 0
      },
      Q_8: {
        A_1: 0,
        A_2: 0,
        A_3: 0,
        A_4: 1
      },
      Q_9: {
        A_1: 0,
        A_2: 0,
        A_3: 0,
        A_4: 1
      },
      Q_10: {
        A_1: 0,
        A_2: 0,
        A_3: 0,
        A_4: 1
      },
      Q_11: {
        A_1: 1,
        A_2: 0,
        A_3: 0,
        A_4: 0
      },
      Q_12: {
        A_1: 0,
        A_2: 0,
        A_3: 1,
        A_4: 0
      },
      Q_13: {
        A_1: 1,
        A_2: 0,
        A_3: 0,
        A_4: 0
      },
      Q_14: {
        A_1: 1,
        A_2: 0,
        A_3: 0,
        A_4: 0
      },
      Q_15: {
        A_1: 0,
        A_2: 0,
        A_3: 0,
        A_4: 1
      },
      Q_16: {
        A_1: 0,
        A_2: 1,
        A_3: 0,
        A_4: 0
      },
      Q_17: {
        A_1: 1,
        A_2: 0,
        A_3: 0,
        A_4: 0
      },
      Q_18: {
        A_1: 0,
        A_2: 0,
        A_3: 1,
        A_4: 0
      }
    },
    BLOCKCHAIN: {
      Q_1: {
        A_1: 0,
        A_2: 0,
        A_3: 0,
        A_4: 1
      },
      Q_2: {
        A_1: 0,
        A_2: 0,
        A_3: 1
      },
      Q_3: {
        A_1: 1,
        A_2: 0,
        A_3: 0,
        A_4: 0
      },
      Q_4: {
        A_1: 0,
        A_2: 1,
        A_3: 0,
        A_4: 0
      },
      Q_5: {
        A_1: 0,
        A_2: 1,
        A_3: 0,
        A_4: 0
      },
      Q_6: {
        A_1: 0,
        A_2: 0,
        A_3: 0,
        A_4: 1
      },
      Q_7: {
        A_1: 0,
        A_2: 1,
        A_3: 0,
        A_4: 0
      },
      Q_8: {
        A_1: 0,
        A_2: 0,
        A_3: 1,
        A_4: 0
      },
      Q_9: {
        A_1: 0,
        A_2: 1,
        A_3: 0,
        A_4: 0
      },
      Q_10: {
        A_1: 0,
        A_2: 0,
        A_3: 0,
        A_4: 1
      },
      Q_11: {
        A_1: 0,
        A_2: 0,
        A_3: 1,
        A_4: 0
      },
      Q_12: {
        A_1: 0,
        A_2: 0,
        A_3: 0,
        A_4: 1
      },
      Q_13: {
        A_1: 0,
        A_2: 0,
        A_3: 1
      },
      Q_14: {
        A_1: 1,
        A_2: 0
      },
      Q_15: {
        A_1: 0,
        A_2: 0,
        A_3: 1,
        A_4: 0
      },
      Q_16: {
        A_1: 0,
        A_2: 0,
        A_3: 0,
        A_4: 1
      },
      Q_17: {
        A_1: 0,
        A_2: 0,
        A_3: 0,
        A_4: 1
      },
      Q_18: {
        A_1: 1,
        A_2: 0,
        A_3: 0,
        A_4: 0
      },
      Q_19: {
        A_1: 0,
        A_2: 0,
        A_3: 0,
        A_4: 1
      },
      Q_20: {
        A_1: 0,
        A_2: 1,
        A_3: 0,
        A_4: 0
      }
    },
    CRYPTOCURRENCY_WALLET: {
      Q_1: {
        A_1: 0,
        A_2: 1
      },
      Q_2: {
        A_1: 0,
        A_2: 0,
        A_3: 0,
        A_4: 1
      },
      Q_3: {
        A_1: 0,
        A_2: 0,
        A_3: 0,
        A_4: 1
      },
      Q_4: {
        A_1: 1,
        A_2: 0,
        A_3: 0
      },
      Q_5: {
        A_1: 0,
        A_2: 0,
        A_3: 1
      },
      Q_6: {
        A_1: 0,
        A_2: 0,
        A_3: 0,
        A_4: 1
      },
      Q_7: {
        A_1: 0,
        A_2: 0,
        A_3: 0,
        A_4: 1
      },
      Q_8: {
        A_1: 0,
        A_2: 0,
        A_3: 0,
        A_4: 1
      },
      Q_9: {
        A_1: 0,
        A_2: 0,
        A_3: 1
      },
      Q_10: {
        A_1: 0,
        A_2: 0,
        A_3: 0,
        A_4: 1
      },
      Q_11: {
        A_1: 0,
        A_2: 0,
        A_3: 0,
        A_4: 1
      },
      Q_12: {
        A_1: 0,
        A_2: 0,
        A_3: 1,
        A_4: 0
      },
      Q_13: {
        A_1: 0,
        A_2: 0,
        A_3: 0,
        A_4: 1
      },
      Q_14: {
        A_1: 0,
        A_2: 1,
        A_3: 0
      },
      Q_15: {
        A_1: 0,
        A_2: 0,
        A_3: 1
      },
      Q_16: {
        A_1: 0,
        A_2: 0,
        A_3: 0,
        A_4: 1
      },
      Q_17: {
        A_1: 1,
        A_2: 0
      },
      Q_18: {
        A_1: 1,
        A_2: 0,
        A_3: 0,
        A_4: 0
      },
      Q_19: {
        A_1: 0,
        A_2: 0,
        A_3: 0,
        A_4: 1
      },
      Q_20: {
        A_1: 0,
        A_2: 1,
        A_3: 0,
        A_4: 0
      },
      Q_21: {
        A_1: 0,
        A_2: 0,
        A_3: 0,
        A_4: 1
      },
      Q_22: {
        A_1: 1,
        A_2: 0,
        A_3: 0,
        A_4: 0
      },
      Q_23: {
        A_1: 1,
        A_2: 0,
        A_3: 0,
        A_4: 0
      },
      Q_24: {
        A_1: 1,
        A_2: 0,
        A_3: 0,
        A_4: 0
      }
    },
    INVESTMENT: {
      Q_1: {
        A_1: 1,
        A_2: 0,
        A_3: 0
      },
      Q_2: {
        A_1: 0,
        A_2: 0,
        A_3: 1
      },
      Q_3: {
        A_1: 0,
        A_2: 0,
        A_3: 0,
        A_4: 1
      },
      Q_4: {
        A_1: 0,
        A_2: 0,
        A_3: 0,
        A_4: 1
      },
      Q_5: {
        A_1: 0,
        A_2: 0,
        A_3: 0,
        A_4: 1
      },
      Q_6: {
        A_1: 0,
        A_2: 0,
        A_3: 0,
        A_4: 1
      },
      Q_7: {
        A_1: 1,
        A_2: 0,
        A_3: 0,
        A_4: 0
      },
      Q_8: {
        A_1: 0,
        A_2: 0,
        A_3: 0,
        A_4: 1
      },
      Q_9: {
        A_1: 0,
        A_2: 1,
        A_3: 0,
        A_4: 0
      },
      Q_10: {
        A_1: 0,
        A_2: 0,
        A_3: 0,
        A_4: 1
      },
      Q_11: {
        A_1: 0,
        A_2: 0,
        A_3: 0,
        A_4: 1
      },
      Q_12: {
        A_1: 1,
        A_2: 0,
        A_3: 0,
        A_4: 0
      },
      Q_13: {
        A_1: 0,
        A_2: 0,
        A_3: 0,
        A_4: 1
      },
      Q_14: {
        A_1: 0,
        A_2: 0,
        A_3: 1,
        A_4: 0
      },
      Q_15: {
        A_1: 1,
        A_2: 0,
        A_3: 0,
        A_4: 0
      },
      Q_16: {
        A_1: 0,
        A_2: 0,
        A_3: 0,
        A_4: 1
      },
      Q_17: {
        A_1: 1,
        A_2: 0,
        A_3: 0,
        A_4: 0
      },
      Q_18: {
        A_1: 0,
        A_2: 0,
        A_3: 1,
        A_4: 0
      },
      Q_19: {
        A_1: 0,
        A_2: 0,
        A_3: 1,
        A_4: 0
      },
      Q_20: {
        A_1: 1,
        A_2: 0,
        A_3: 0,
        A_4: 0
      },
      Q_21: {
        A_1: 0,
        A_2: 1,
        A_3: 0,
        A_4: 0
      }
    }
  }
}
